import { Box, Typography, Divider } from "@mui/material";

// const renderText = (label, value) => (
//   <Typography>
//     <strong>{label}:</strong> {value ?? "нет данных"}
//   </Typography>
// );

// const renderArray = (label, arr) => (
//   <Typography>
//     <strong>{label}:</strong>{" "}
//     {Array.isArray(arr) && arr.length > 0 ? arr.join(", ") : "нет данных"}
//   </Typography>
// );

// const renderMinMax = (label, obj) => {
//   if (!obj || (obj.min == null && obj.max == null))
//     return renderText(label, "нет данных");

//   return (
//     <Typography>
//       <strong>{label}:</strong> {obj.min ?? "-"} – {obj.max ?? "-"}
//     </Typography>
//   );
// };

const formatValue = (value) => {
  if (value === null || value === undefined) return "нет данных";

  // строки и числа
  if (typeof value === "string" || typeof value === "number") {
    return value;
  }

  // boolean
  if (typeof value === "boolean") {
    return value ? "Да" : "Нет";
  }

  // массивы
  if (Array.isArray(value)) {
    if (value.length === 0) return "нет данных";

    // массив примитивов
    if (value.every((v) => typeof v === "string" || typeof v === "number")) {
      return value.join(", ");
    }

    // массив объектов (например упаковки)
    return value
      .map((v) => {
        if (typeof v === "object") {
          if ("size" in v && "unit" in v) {
            return `${v.size} ${v.unit}`;
          }
          return JSON.stringify(v);
        }
        return String(v);
      })
      .join(", ");
  }

  // min/max
  if (typeof value === "object") {
    if ("min" in value || "max" in value) {
      return `${value.min ?? "-"} – ${value.max ?? "-"}`;
    }
  }

  return "нет данных";
};

const renderField = (label, value) => (
  <Typography>
    <strong>{label}:</strong> {formatValue(value)}
  </Typography>
);

export const LotAnalysisDetails = ({ summary }) => {
  if (!summary) {
    return <Typography color="text.secondary">Нет данных анализа</Typography>;
  }

  const {
    requirement,
    query,
    enstru_code,
    extraction_meta,
    paint,
    appearance,
    application,
    performance,
    conditions,
    packaging,
    standards,
    economics,
    risk_flags,
    ktru_hints,
    confidence_overall,
    ktru_code,
    id,
    isVD,
    chemicalType,
    usage,
    unit,
    packSize,
    quantity,
    totalPrice,
  } = summary;

  return (
    <Box sx={{ maxHeight: 600, overflowY: "auto", p: 1 }}>
      {/* === Запрос === */}
      <Typography variant="subtitle1" fontWeight={600}>
        Запрос
      </Typography>
      {renderField("Запрос заказчика", query)}
      {renderField("Требование", requirement)}
      <Divider sx={{ my: 2 }} />

      {/* === ENSTRU === */}
      {renderField("ENSTRU код", enstru_code)}
      <Divider sx={{ my: 2 }} />

      {/* === Метаданные === */}
      <Typography variant="subtitle1" fontWeight={600}>
        Метаданные извлечения
      </Typography>
      {renderField("Версия", extraction_meta?.version)}
      {renderField("Примечания", extraction_meta?.notes)}
      <Divider sx={{ my: 2 }} />

      {/* === KTRU === */}
      <Typography variant="subtitle1" fontWeight={600}>
        КТРУ
      </Typography>
      {renderField("Код", ktru_code?.code)}
      {renderField("Название", ktru_code?.name)}
      {renderField("Характеристики", ktru_code?.characteristics)}
      <Divider sx={{ my: 2 }} />

      {/* === Материал === */}
      <Typography variant="subtitle1" fontWeight={600}>
        Материал
      </Typography>
      {renderField("Тип", paint?.type)}
      {renderField("Уверенность (тип)", paint?.type_confidence)}
      {renderField("Подтип", paint?.subtype)}
      {renderField("Уверенность (подтип)", paint?.subtype_confidence)}
      {renderField("Связующее", paint?.binder)}
      {renderField("Растворитель", paint?.solvent)}
      {renderField("Двухкомпонентная", paint?.two_component ? "Да" : "Нет")}
      <Divider sx={{ my: 2 }} />

      {/* === Внешний вид === */}
      <Typography variant="subtitle1" fontWeight={600}>
        Внешний вид
      </Typography>
      {renderField("Цвет", appearance?.color)}
      {renderField("Глянец", appearance?.gloss)}
      {renderField("База", appearance?.base)}
      {renderField("RAL", appearance?.ral)}
      <Divider sx={{ my: 2 }} />

      {/* === Применение === */}
      <Typography variant="subtitle1" fontWeight={600}>
        Применение
      </Typography>
      {renderField("Место", application?.location)}
      {renderField("Основания", application?.substrates)}
      {renderField("Назначение", application?.purpose)}
      <Divider sx={{ my: 2 }} />

      {/* === Показатели === */}
      <Typography variant="subtitle1" fontWeight={600}>
        Показатели
      </Typography>
      {renderField("Покрываемость (м2/л)", performance?.coverage_m2_per_l)}
      {renderField("Расход (л/м2)", performance?.consumption_l_per_m2)}

      {renderField("Плотность", performance?.density_kg_per_l)}
      {renderField("Вязкость", performance?.viscosity)}
      {renderField("Класс мытья", performance?.wash_class)}

      {renderField(
        "Толщина мокрого слоя (мкм)",
        performance?.film_thickness_wet_um
      )}
      {renderField(
        "Толщина сухого слоя (мкм)",
        performance?.film_thickness_dry_um
      )}

      {renderField("Водостойкость", performance?.resistance_water)}
      {renderField("Химстойкость", performance?.resistance_chemical)}
      {renderField("УФ-стойкость", performance?.resistance_uv)}
      {renderField("Щелочестойкость", performance?.resistance_alkali)}
      {renderField("Морозостойкость", performance?.resistance_frost)}
      {renderField("VOC", performance?.voc_g_per_l)}

      <Divider sx={{ my: 2 }} />

      {/* === Условия === */}
      <Typography variant="subtitle1" fontWeight={600}>
        Условия нанесения
      </Typography>
      {renderField("Температура нанесения", conditions?.application_temp_C)}
      {renderField("Максимальная влажность", conditions?.humidity_max_pct)}
      {renderField("Температура поверхности", conditions?.surface_temp_C)}
      {renderField(
        "Учитывать точку росы",
        conditions?.dew_point_note ? "Да" : "Нет"
      )}
      {renderField("Инструменты", conditions?.tools)}
      {renderField("Разбавление (%)", conditions?.thinning_pct)}
      <Divider sx={{ my: 2 }} />

      {/* === Упаковка === */}
      <Typography variant="subtitle1" fontWeight={600}>
        Упаковка
      </Typography>
      <Typography>
        <strong>Упаковки:</strong>{" "}
        {Array.isArray(packaging?.packs) && packaging.packs.length > 0
          ? packaging.packs.map((p) => `${p.size} ${p.unit}`).join(", ")
          : "нет данных"}
      </Typography>
      {renderField("Количество", packaging?.qty_total)}
      {renderField("Объем (л)", packaging?.total_volume_L)}
      {renderField("Конвертация", packaging?.unit_conversion_used)}
      <Divider sx={{ my: 2 }} />

      {/* === Стандарты === */}
      <Typography variant="subtitle1" fontWeight={600}>
        Стандарты
      </Typography>
      {renderField("ГОСТ/ТУ", standards?.gost_tu)}
      {renderField("ISO/EN", standards?.iso_en)}
      {renderField("СанПиН", standards?.sanpin_other)}
      <Divider sx={{ my: 2 }} />

      {/* === Экономика === */}
      <Typography variant="subtitle1" fontWeight={600}>
        Экономика
      </Typography>
      {renderField(
        "Нормализованная цена (тг/л)",
        economics?.normalized_price_TNG_per_L
      )}
      <Divider sx={{ my: 2 }} />

      {/* === Риски === */}
      <Typography variant="subtitle1" fontWeight={600}>
        Риски
      </Typography>
      {Object.entries(risk_flags ?? {}).map(([key, val]) =>
        renderField(key, val)
      )}
      <Divider sx={{ my: 2 }} />

      {/* === Подсказки === */}
      <Typography variant="subtitle1" fontWeight={600}>
        КТРУ подсказки
      </Typography>
      {renderField("По ключевым словам", ktru_hints?.by_keywords)}
      {renderField("По атрибутам", ktru_hints?.by_attributes)}
      {renderField(
        "Конфликт с КТРУ заказчика",
        ktru_hints?.conflict_with_customer_ktru ? "Да" : "Нет"
      )}
      <Divider sx={{ my: 2 }} />

      {/* === Уверенность === */}
      {renderField("Уверенность анализа", confidence_overall)}
      <Divider sx={{ my: 2 }} />

      {/* === Дополнительно === */}
      <Typography variant="subtitle1" fontWeight={600}>
        Дополнительно
      </Typography>
      {renderField("ID", id)}
      {renderField("Является ВД", isVD ? "Да" : "Нет")}
      {renderField("Химический тип", chemicalType)}
      {renderField("Использование", usage)}
      {renderField("Единица", unit)}
      {renderField("Размер упаковки", packSize)}
      {renderField("Количество", quantity)}
      {renderField("Итоговая цена", totalPrice)}
    </Box>
  );
};
